import React, { Fragment } from "react";
import { Footerlight, PageLayout } from "../../../Constant";
import InvoiceContainer from "./InvoiceList";

const InvoiceTable = () => {
    return (
        <Fragment>
            <InvoiceContainer mainTitle={Footerlight} title={Footerlight} parent={PageLayout} />  
        </Fragment>
    )
}
export default InvoiceTable;